import React, { Component } from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


am4core.useTheme(am4themes_animated);
am4core.addLicense("CH258896422");


export default class DualAxisCompareLineChart extends Component {



  componentDidMount() {
    let info = this.props
    let metric_1 = info['metric_1'];
    let metric_2 = info['metric_2'];
    let titleX = info['Xtitle']
    let titleY = info['Ytitle']
    let titleY2 = info['Ytitle2']

    let chart_id = info['chart_id'];
    let data = info['graph-data'];

    let chart = am4core.create(chart_id, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();
    chart.fontFamily = "Ubuntu"; //TO CHANGE FONT SIZE OF CHART LABELS
    chart.fontSize = 12; //TO CHANGE FONT SIZE OF CHART LABELS

    // FOR FORMATTING LARGE NUMBERS
    if (this.props.isnumber == 'money') {
      chart.numberFormatter.numberFormat = "#.##a";
      chart.numberFormatter.bigNumberPrefixes = [
        { "number": 1e+3, "suffix": "K" },
        { "number": 1e+5, "suffix": "L" },
        { "number": 1e+7, "suffix": "Cr" }
      ];
    } else {
      chart.numberFormatter.numberFormat = "#.##a";
      chart.numberFormatter.bigNumberPrefixes = [
        { "number": 1e+3, "suffix": "K" },
        { "number": 1e+6, "suffix": "M" },
        { "number": 1e+9, "suffix": "G" }
      ];
    }


    chart.data = data;
    // Create axes
    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    // dateAxis.renderer.grid.template.strokeWidth = 0; //disable vertical lines
    dateAxis.renderer.line.strokeOpacity = 0.2; // for reducing the x axis opacity 
    dateAxis.renderer.line.stroke = am4core.color("#707070"); // for changing the x axis color
    // dateAxis.renderer.minGridDistance = 30;
    dateAxis.renderer.labels.template.fill = "#757575"; //TO CHANGE COLOR OF X AXIS LABELS
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0;
    dateAxis.tooltip.disabled = true; // for disabling to the x axis tooltip
    dateAxis.renderer.opposite = false;
    dateAxis.title.text = titleX;


    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    //  valueAxis.renderer.minGridDistance = 20;
    valueAxis.renderer.line.strokeOpacity = 0; // for reducing the x axis opacity 
    valueAxis.renderer.line.stroke = am4core.color("#707070"); // for changing the Y axis color
    valueAxis.renderer.grid.template.strokeWidth = 0; //disable horizontal lines
    valueAxis.renderer.line.strokeOpacity = 0.2; // for reducing the Y axis opacity 
    valueAxis.tooltip.disabled = true; // for disabling to the y axis tooltip
    valueAxis.min = 132000;
    valueAxis.title.text = titleY;


    var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
    //  valueAxis2.renderer.minGridDistance = 20;
    valueAxis2.renderer.opposite = true;
    valueAxis2.renderer.line.strokeOpacity = 0; // for reducing the x axis opacity 
    valueAxis2.renderer.line.stroke = am4core.color("#707070"); // for changing the Y axis color
    valueAxis2.renderer.grid.template.strokeWidth = 0; //disable horizontal lines
    valueAxis2.renderer.line.strokeOpacity = 0.2; // for reducing the Y axis opacity 
    valueAxis2.tooltip.disabled = true; // for disabling to the y axis tooltip
    valueAxis2.min = 0;
    valueAxis2.title.text = titleY2;

    // Create series
    var series = chart.series.push(new am4charts.LineSeries());
    series.name = metric_1
    series.dataFields.valueY = "value1";
    series.dataFields.dateX = "date";
    series.strokeWidth = 2;
    series.stroke = "#11A1FD";
    series.fill = "#11A1FD";
    series.fillOpacity = 0.1;
    // series.minBulletDistance = 10;
    series.tensionX = 0.8;

    var tooltipHTML =
      `
     <div class="w-100 d-flex flex-column justify-space-between" style="width: 100%">
       <div class="text-left d-flex flex-column justify-start" style="width: 150px; padding:10px">
          <span style="font-size: 13px; color: #fff; font-weight: 400">{value1}</span>
          <span style="font-size: 12px; color: #7D9EB5; font-weight: 300">` + metric_1 + `</span>
          <hr style="margin: 4px 0"/>
          <span style="font-size: 13px; color: #fff; font-weight: 400">{value2}</span>
          <span style="font-size: 12px; color: #7D9EB5; font-weight: 300">` + metric_2 + `</span>
       </div>
     </div>
     `;

    // Tooltip 
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#213345");
    series.tooltip.background.stroke = am4core.color("#213345");
    series.tooltip.background.cornerRadius = 5;
    series.tooltip.label.minWidth = 150;
    series.tooltip.label.padding(0, 0, 0, 0);
    series.tooltip.label.fontSize = 12;
    series.tooltip.position = "pointer";
    // series.tooltip.pointerOrientation = "vertical";
    series.tooltipHTML = tooltipHTML;
    var shadow = series.tooltip.background.filters.getIndex(0);
    shadow.dx = 3;
    shadow.dy = 10;
    shadow.blur = 10;
    shadow.color = am4core.color("#14567829");


    // Create series
    var series2 = chart.series.push(new am4charts.LineSeries());
    series2.name = metric_2;
    series2.dataFields.valueY = "value2";
    series2.dataFields.dateX = "date";
    series2.yAxis = valueAxis2;
    series2.strokeWidth = 2;
    series2.stroke = series.stroke;
    series2.stroke = "#FF9931";
    series2.fill = "#FF9931";
    series2.fillOpacity = 0.2;
    series2.tensionX = 0.8;
    // series2.bullets.push(new am4charts.CircleBullet());

    // Lineargradient
    let fillModifier = new am4core.LinearGradientModifier();
    fillModifier.opacities = [1, 1, 0];
    fillModifier.offsets = [0, 0.5, 1];
    fillModifier.gradient.rotation = 90;
    series.segments.template.fillModifier = fillModifier;
    series2.segments.template.fillModifier = fillModifier;

    // Add chart cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "zoomY";


    // LEGEND
    chart.legend = new am4charts.Legend();
    chart.legend.useDefaultMarker = true;
    chart.legend.labels.template.text = "{name}";
    chart.legend.labels.template.fill = "#213345";
    chart.legend.fill = "rgba(112, 112, 112, 0.1)";
    chart.legend.opacity = 1;
    var markerTemplate = chart.legend.markers.template;
    let marker = chart.legend.markers.template.children.getIndex(0);
    marker.cornerRadius(12, 12, 12, 12);
    markerTemplate.width = 13;
    markerTemplate.height = 13;

    valueAxis.renderer.line.strokeOpacity = 1;
    valueAxis.renderer.line.strokeWidth = 2;
    valueAxis.renderer.line.stroke = series.stroke;
    valueAxis.renderer.labels.template.fill = series.stroke;

    valueAxis2.renderer.line.strokeOpacity = 1;
    valueAxis2.renderer.line.strokeWidth = 2;
    valueAxis2.renderer.line.stroke = series2.stroke;
    valueAxis2.renderer.labels.template.fill = series2.stroke;

  }


  render() {

    let chart_class = this.props.chart_class;
    let chart_id = this.props.chart_id;

    return (
      <div id={chart_id} className={chart_class}></div>
    )
  }
}
